
const digest = '0e32d1710f111754467b8dafe6cc49b0fd34d7f937543412a0a6ce7987057f5c';
const classes = {"fileUpload":"_fileUpload_vacmd_1","filePreview":"_filePreview_vacmd_5","removeButton":"_removeButton_vacmd_12","filePreviewBackground":"_filePreviewBackground_vacmd_18","attachment":"_attachment_vacmd_24","wrapper":"_wrapper_vacmd_37","chatLanguage":"_chatLanguage_vacmd_43","inputWrapper":"_inputWrapper_vacmd_51","messageWrapper":"_messageWrapper_vacmd_59","inputGroup":"_inputGroup_vacmd_63","customFile":"_customFile_vacmd_70","textArea":"_textArea_vacmd_77","subMenu":"_subMenu_vacmd_81","plusButton":"_plusButton_vacmd_84","menu":"_menu_vacmd_93","close":"_close_vacmd_106","phrasesButton":"_phrasesButton_vacmd_116","icon":"_icon_vacmd_124","filesWrapper":"_filesWrapper_vacmd_134"};
const css = `._fileUpload_vacmd_1 {
  display: none;
}

._filePreview_vacmd_5 {
  margin-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
}
._filePreview_vacmd_5 ._removeButton_vacmd_12 {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

._filePreviewBackground_vacmd_18 {
  background-repeat: no-repeat;
  background-position: center;
  border: 0;
}

._attachment_vacmd_24 {
  background: url("/dist/icons/react/attachment.svg") no-repeat left;
  background-size: contain;
  cursor: pointer;
  display: flex;
  margin-bottom: 0;
  width: max-content;
  height: 30px;
  padding-left: 40px;
  align-items: center;
  font-size: 14px;
}

._wrapper_vacmd_37 {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-top: 1px solid #eaedf3;
}
._wrapper_vacmd_37 ._chatLanguage_vacmd_43 {
  padding: 5px 24px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  background: #e9effb;
  color: #2b2f33;
}
._wrapper_vacmd_37 ._inputWrapper_vacmd_51 {
  padding: 24px;
  display: flex;
  flex-direction: row;
  gap: 9px;
  align-items: flex-end;
}

._messageWrapper_vacmd_59 {
  flex-grow: 1;
}

._inputGroup_vacmd_63 {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

._customFile_vacmd_70 {
  position: relative;
  display: inline-block;
  width: 100%;
  margin-bottom: 0;
}

._textArea_vacmd_77 {
  margin-bottom: -3px;
}

._subMenu_vacmd_81 {
  position: relative;
}
._subMenu_vacmd_81 ._plusButton_vacmd_84 {
  border-radius: 100%;
  width: 49px;
  height: 49px;
  background: #e9effb url("/dist/icons/react/plus-blue.svg") no-repeat center;
  background-size: 25px;
  cursor: pointer;
  aspect-ratio: 1/1;
}
._subMenu_vacmd_81 ._menu_vacmd_93 {
  position: absolute;
  padding: 24px 24px 48px 24px;
  background-color: #ffffff;
  border-radius: 25px;
  border: 1px solid #eaedf3;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.1);
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._subMenu_vacmd_81 ._menu_vacmd_93 ._close_vacmd_106 {
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: 20px;
  height: 20px;
  background: url("/dist/icons/react/xmark-blue.svg") no-repeat center;
  background-size: contain;
  cursor: pointer;
}
._subMenu_vacmd_81 ._menu_vacmd_93 ._phrasesButton_vacmd_116 {
  display: flex;
  align-items: center;
  gap: 10px;
  width: max-content;
  cursor: pointer;
  font-size: 14px;
}
._subMenu_vacmd_81 ._menu_vacmd_93 ._phrasesButton_vacmd_116 ._icon_vacmd_124 {
  border-radius: 100%;
  width: 30px;
  height: 30px;
  background: #e9effb url("/dist/icons/react/chat-lines-blue.svg") no-repeat center;
  background-size: 11px;
  cursor: pointer;
  aspect-ratio: 1/1;
}

._filesWrapper_vacmd_134 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  flex-direction: row;
  gap: 10px;
  padding: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  